import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-25',
  templateUrl: './25.component.html',
})
export class VbList25Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
